import type { IconName } from '@customerio/pluma-icons';

export function getFileIcon(mimeType: string): IconName {
  if (mimeType.startsWith('image/')) return 'image';
  if (mimeType === 'application/pdf') return 'file-pdf';
  if (mimeType === 'text/markdown') return 'file-md';
  if (mimeType.startsWith('text/')) return 'plaintext';
  return 'paperclip';
}
